const cancelRecordList = []
const staffInfos = []
const appointmentRecord = []

export default {
  cancelRecordList,
  staffInfos,
  appointmentRecord
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/store/state.js